// ------------------------------------
// Mosaico (Masonry)
// ------------------------------------
(function () {
  "use strict";
  var $mosaico = $(".mosaico-lista");
  if ($mosaico.length > 0) {
    $mosaico.each(function () {
      var $grid = $(this);
      $grid.imagesLoaded(function () {
        $grid.masonry({
          itemSelector: ".galeria-thumb",
          percentPosition: true,
          gutter: ".gutter-sizer",
        });
      });

      // Relayout quando o lazysizes troca o placeholder pela imagem real,
      // já que a altura do item muda depois do imagesLoaded inicial
      $grid.on("lazyloaded", "img", function () {
        $grid.masonry("layout");
      });
    });
  }
})();
